"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports["default"] = _default;